module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/program-cedad08749c18f4827fdee7b52baebad.jpeg";